import React, { useState, useEffect } from 'react';
import { ShieldAlert, RefreshCw } from 'lucide-react';
import apiService from '../../../services/apiService';

const SecurityAlertsTab = () => {
  const [alerts, setAlerts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchAlerts = async () => {
    setLoading(true);
    try {
      const data = await apiService.getSecurityAlerts();
      setAlerts(data.alerts || []);
      setError(null);
    } catch (e) {
      setError(e.message || 'Failed to load security alerts');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchAlerts(); }, []);

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '24px' }}>
        <h2 style={{ color: '#e2e8f0', display: 'flex', alignItems: 'center', gap: '10px', fontSize: '26px' }}>
          <ShieldAlert size={26} style={{ color: '#ef4444' }} />
          Security Alerts
        </h2>
        <button
          onClick={fetchAlerts}
          style={{ display: 'flex', alignItems: 'center', gap: '6px', padding: '8px 14px', background: 'rgba(59,130,246,0.2)', border: '1px solid rgba(59,130,246,0.4)', borderRadius: '8px', color: '#3b82f6', cursor: 'pointer' }}
        >
          <RefreshCw size={16} /> Refresh
        </button>
      </div>

      {error && <div style={{ color: '#ef4444', marginBottom: '16px' }}>Error: {error}</div>}
      {loading ? (
        <p style={{ color: '#94a3b8' }}>Loading...</p>
      ) : alerts.length === 0 ? (
        <p style={{ color: '#94a3b8' }}>No security alerts recorded.</p>
      ) : (
        <div style={{ background: 'rgba(15,23,42,0.8)', borderRadius: '12px', overflow: 'hidden', border: '1px solid rgba(59,130,246,0.2)' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: 'rgba(59,130,246,0.15)', color: '#94a3b8', textAlign: 'left' }}>
                <th style={{ padding: '12px 16px' }}>Time</th>
                <th style={{ padding: '12px 16px' }}>IP Address</th>
                <th style={{ padding: '12px 16px' }}>Action</th>
                <th style={{ padding: '12px 16px' }}>Failures</th>
                <th style={{ padding: '12px 16px' }}>Expires</th>
              </tr>
            </thead>
            <tbody>
              {alerts.map((a) => (
                <tr key={a._id} style={{ borderTop: '1px solid rgba(59,130,246,0.1)' }}>
                  <td style={{ padding: '12px 16px', color: '#e2e8f0' }}>{new Date(a.createdAt).toLocaleString()}</td>
                  <td style={{ padding: '12px 16px', color: '#e2e8f0' }}>{a.ip}</td>
                  <td style={{ padding: '12px 16px' }}>
                    <span style={{
                      padding: '2px 10px', borderRadius: '12px', fontSize: '12px', fontWeight: 600,
                      background: a.action === 'ban' ? 'rgba(239,68,68,0.2)' : 'rgba(34,197,94,0.2)',
                      color: a.action === 'ban' ? '#ef4444' : '#22c55e'
                    }}>
                      {a.action.toUpperCase()}
                    </span>
                  </td>
                  <td style={{ padding: '12px 16px', color: '#e2e8f0' }}>{a.failureCount ?? '—'}</td>
                  <td style={{ padding: '12px 16px', color: '#e2e8f0' }}>{a.expiresAt ? new Date(a.expiresAt).toLocaleString() : '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default SecurityAlertsTab;
